function i4_Toggle(element) {
    this.$element = $(element);

    this.selectors = {
	    trigger: '.js-toggle-trigger',
	    container: '.js-toggle-container'
    };
    
    this.modifiers = {
	    open: 'i4-toggle--open'
    };
    
    this.data = {
	    open: 'open'
    };
    
    this.init = function() {
	    this.$trigger = this.$element.find(this.selectors.trigger);    
	    this.$container = this.$element.find(this.selectors.container);  
	    
	    this.open = this.$element.data(this.data.open);
	    
	    this.$trigger.on('click', this.$onClickTrigger.bind(this)); 
	    
	    if (this.open) {
		    this.$element.addClass(this.modifiers.open);
	    } 
	};
	
	this.$onClickTrigger = function() {
		this.$element.toggleClass(this.modifiers.open);
	};
}
